import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import IncomeNewEditForm from './IncomeNewEditForm';
// ----------------------------------------------------------------------

export default function IncomeCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('Income.CreateIncome')}` : `${translate('Income.UpdateIncome')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Income.CreateIncome')}`
              : `${translate('Income.EditIncome')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('Income.IncomeList')}`,
              href: PATH_DASHBOARD.Income.list,
            },
            {
              name: !isEdit
                ? `${translate('Income.CreateIncome')}`
                : `${translate('Income.UpdateIncome')}`,
            },
          ]}
        />
        <IncomeNewEditForm />
      </Container>
    </Page>
  );
}
